import { Multiselect } from "multiselect-react-dropdown";
import {
    Button,
    Card,
    Col,
    FormControl,
    FormGroup,
    FormLabel,
    FormText,
    Row,
  } from "react-bootstrap";
  import Breadcrumb from "app/components/Breadcrumb";
  import { useState } from "react";

export default function Dropdown() {
const [adminFilters, setAdminFilters] = useState({
    policyNumber: "",
    insurer: [],
    policyType: [],
    customerName: "",
    policyPeriodFrom: "",
    policyPeriodTo: "",
});

const handleAdminFilterChange = (e) => {
    const { id, value } = e.target;
    setAdminFilters((prevFilters) => ({
        ...prevFilters,
        [id]: value,
    }));
};


const handleMultiSelectChange = (selectedList, selectedItem, id) => {
    setAdminFilters((prevFilters) => ({
        ...prevFilters,
        [id]: selectedList,
    }));
};

return (
    <section>
        <Breadcrumb
          routeSegments={[
            { name: "Forms", path: "/forms" },
            { name: "Dropdown" },
          ]}
        />
        <Row>
            <Col xs={12}>
                <Card>
                    <Card.Header>
                        <Card.Title className="mb-0">Dropdown Form</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <FormGroup controlId="policyNumber" className="col-md-4">
                                <FormLabel>Policy Number:</FormLabel>
                                <FormControl
                                    type="text"
                                    placeholder="Enter policy number"
                                    value={adminFilters.policyNumber}
                                    onChange={handleAdminFilterChange}
                                />
                            </FormGroup>

                            <FormGroup controlId="insurer" className="col-md-4">
                                <FormLabel>Insurer:</FormLabel>
                                <Multiselect
                                    options={["Insurer1", "Insurer2", "Insurer3"]}
                                    selectedValues={adminFilters.insurer}
                                    onSelect={(selectedList, selectedItem) =>
                                        handleMultiSelectChange(selectedList, selectedItem, "insurer")
                                    }
                                    onRemove={(selectedList, selectedItem) =>
                                        handleMultiSelectChange(selectedList, selectedItem, "insurer")
                                    }
                                    displayValue="name"
                                />
                            </FormGroup>

                            <FormGroup controlId="policyType" className="col-md-4">
                                <FormLabel>Policy Type:</FormLabel>
                                <Multiselect
                                    options={[
                                        "Workers' Compensation",
                                        "Errors & Omissions",
                                        "General Liability",
                                        "Commercial Property",
                                        "Product Liability",
                                        "Cybersecurity",
                                        "Other",
                                    ]}
                                    selectedValues={adminFilters.policyType}
                                    onSelect={(selectedList, selectedItem) =>
                                        handleMultiSelectChange(selectedList, selectedItem, "policyType")
                                    }
                                    onRemove={(selectedList, selectedItem) =>
                                        handleMultiSelectChange(selectedList, selectedItem, "policyType")
                                    }
                                    displayValue="name"
                                />
                            </FormGroup>
                        </Row>

                        <Row>
                            <FormGroup controlId="customerName" className="col-md-4">
                                <FormLabel>Customer Name:</FormLabel>
                                <FormControl
                                    type="text"
                                    placeholder="Enter customer name"
                                    value={adminFilters.customerName}
                                    onChange={handleAdminFilterChange}
                                />
                            </FormGroup>

                            <FormGroup controlId="policyPeriodFrom" className="col-md-4">
                                <FormLabel>Policy Period From:</FormLabel>
                                <FormControl
                                    type="date"
                                    value={adminFilters.policyPeriodFrom}
                                    onChange={handleAdminFilterChange}
                                />
                            </FormGroup>

                            <FormGroup controlId="policyPeriodTo" className="col-md-4">
                                <FormLabel>Policy Period To:</FormLabel>
                                <FormControl
                                    type="date"
                                    value={adminFilters.policyPeriodTo}
                                    onChange={handleAdminFilterChange}
                                />
                            </FormGroup>
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    </section>
);
}